import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import LazyLoad from 'react-lazyload';
import { useStyles } from './styles';
import Image from 'next/image';

const Props = {
  textTitle: PropTypes.string.isRequired,
};

export default function TrustedOneHundredInstitutions({ textTitle }) {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box py={6} bgcolor="#FFFFFF">
        <Container>
          <Typography className={classes.primaryColor} variant="h4" component="h2" align="center">
            <b>{textTitle}</b>
          </Typography>

          <Box className={classes.mainBoxImages} pt={4}>
            <Image
              src="/images/logos-academics-institutions/texas-medical-center-icon.png"
              alt="texas medical center icon"
              loading="lazy"
              width={148}
              height={47}
            />

            <Image
              src="/images/logos-academics-institutions/pearson-icon.png"
              alt="pearson icon"
              loading="lazy"
              width={70}
              height={50}
            />

            <Image
              src="/images/logos-academics-institutions/stanford-university-icon.png"
              alt="stanford icon"
              loading="lazy"
              width={112}
              height={50}
            />

            <Image
              src="/images/logos-academics-institutions/abbott-icon.png"
              alt="abbott icon"
              loading="lazy"
              width={89}
              height={66}
            />

            <Image
              src="/images/logos-academics-institutions/mcgill-icon.png"
              alt="mcgill icon"
              loading="lazy"
              width={100}
              height={24}
            />

            <Image
              src="/images/logos-academics-institutions/plattsburgh-icon.png"
              alt="plattsburgh icon"
              loading="lazy"
              width={133}
              height={23}
            />

            <img
              src="/images/logos-academics-institutions/texas-university-icon.png"
              alt="texas university icon"
              loading="lazy"
              width={139}
              height={40}
            />

            <img
              src="/images/logos-academics-institutions/pennvet-icon.png"
              alt="pennvet icon"
              loading="lazy"
              width={152}
              height={39}
            />
          </Box>

          <Box className={classes.mainBoxImages}>
            <Image
              src="/images/logos-academics-institutions/cornell-university-icon.png"
              alt="cornell icon"
              loading="lazy"
              width={166}
              height={93}
            />

            <Image
              src="/images/logos-academics-institutions/ucsf-icon.png"
              alt="ucsf icon"
              loading="lazy"
              width={129}
              height={94}
            />

            <Image
              src="/images/logos-academics-institutions/harvard-icon.png"
              alt="harvard icon"
              loading="lazy"
              width={201}
              height={49}
            />

            <Image
              src="/images/logos-academics-institutions/vanderbilt-icon.png"
              alt="vanderbild icon"
              loading="lazy"
              width={145}
              height={81}
            />

            <Image
              src="/images/logos-academics-institutions/ua-stack-icon.png"
              alt="arizona university icon"
              loading="lazy"
              width={82}
              height={76}
            />

            <Image
              src="/images/logos-academics-institutions/rutgers-university-icon.png"
              alt="rutgers icon"
              loading="lazy"
              width={166}
              height={45}
            />

            <Image
              src="/images/logos-academics-institutions/pacific-icon.png"
              alt="pacific icon"
              loading="lazy"
              width={137}
              height={76}
            />
          </Box>

          <Box className={classes.mainBoxImages}>
            <Image
              src="/images/logos-academics-institutions/universityofpennsylvania-icon.png"
              alt="penn icon"
              loading="lazy"
              width={140}
              height={93}
            />

            <Image
              src="/images/logos-academics-institutions/emory-icon.png"
              alt="emory icon"
              loading="lazy"
              width={143}
              height={37}
            />

            <Image
              src="/images/logos-academics-institutions/darthmouth-icon.png"
              alt="darthmouth icon"
              loading="lazy"
              width={104}
              height={59}
            />

            <Image
              src="/images/logos-academics-institutions/ucla-health-icon.png"
              alt="ucla health icon"
              loading="lazy"
              width={192}
              height={41}
            />

            <Image
              src="/images/logos-academics-institutions/concordia-chicado-icon.png"
              alt="concordia icon"
              loading="lazy"
              width={133}
              height={60}
            />

            <Image
              src="/images/logos-academics-institutions/oregon-health-science-university-icon.png"
              alt="oregon health icon"
              loading="lazy"
              width={115}
              height={80}
            />

            <Image
              src="/images/logos-academics-institutions/duke-icon.png"
              alt="duke icon"
              loading="lazy"
              width={119}
              height={52}
            />
          </Box>

          <Box className={classes.mainBoxImages}>
            <Image
              src="/images/logos-academics-institutions/usc-university-icon.png"
              alt="usc university icon"
              loading="lazy"
              width={189}
              height={41}
            />

            <Image
              src="/images/logos-academics-institutions/baylor-university-icon.png"
              alt="baylor icon"
              loading="lazy"
              width={210}
              height={118}
            />

            <Image
              src="/images/logos-academics-institutions/hawait-icon.png"
              alt="hawait icon"
              loading="lazy"
              width={212}
              height={37}
            />

            <Image
              src="/images/logos-academics-institutions/uepa-icon.png"
              alt="uepa icon"
              loading="lazy"
              width={135}
              height={48}
            />

            <Image
              src="/images/logos-academics-institutions/uc-icon.png"
              alt="uc icon"
              loading="lazy"
              width={210}
              height={44}
            />

            <Image
              src="/images/logos-academics-institutions/logo-ufop-icon.png"
              alt="ufop icon"
              loading="lazy"
              width={53}
              height={111}
            />
          </Box>

          <Box className={classes.mainBoxImages}>
            <Image
              src="/images/logos-academics-institutions/columbia-university-icon.png"
              alt="columbia university icon"
              loading="lazy"
              width={218}
              height={121}
            />

            <Image
              src="/images/logos-academics-institutions/colorado-icon.png"
              alt="colorado icon"
              loading="lazy"
              width={79}
              height={79}
            />

            <Image
              src="/images/logos-academics-institutions/arabian-icon.png"
              alt="arabian icon"
              loading="lazy"
              width={102}
              height={102}
            />

            <Image
              src="/images/logos-academics-institutions/western-icon.png"
              alt="wester icon"
              loading="lazy"
              width={89}
              height={89}
            />

            <Image
              src="/images/logos-academics-institutions/reed-college-icon.png"
              alt="reed college icon"
              loading="lazy"
              width={98}
              height={52}
            />

            <Image
              src="/images/logos-academics-institutions/university-of-minnesota-icon.png"
              alt="minnesota icon"
              loading="lazy"
              width={117}
              height={71}
            />

            <Image
              src="/images/logos-academics-institutions/mayo-clinic-icon.png"
              alt="mayo clinic icon"
              loading="lazy"
              width={67}
              height={74}
            />
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}

TrustedOneHundredInstitutions.propTypes = Props;
